// Module
var code = "<template><require from=\"../../../../components/rich-text-editor/rich-text-editor\"></require><rich-text-editor class=\"column grow-xs-1 padding-10 animation-page-slide-bottom\" html.two-way=\"lotteryAdditionalInfo.faq\"></rich-text-editor></template>";
// Exports
module.exports = code;